<script>
    let button;
    export let click;
    export let buttonId;
    export let floatText;
    export let disabled = false;
    import {onMount} from "svelte";
    import {textFloaty} from "../directives/textFloaty";
    onMount(() => {
        if (buttonId) button.id = buttonId
    })
</script>

<style>
    button {
        position: relative;
        transition: all 0.2s;
        background: #FFFFFF;
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        border-radius: 28px;
        height: 56px;
        padding: 0 48px;
        font-weight: 600;
        text-align: center;
        color: #FE520A;
        cursor: pointer;
        margin-top: 12px;
    }
    button:hover {
        transform: translateY(-2px);
        box-shadow: 4px 8px 20px rgba(215, 74, 9, 0.4);
    }
    button:active {
        background-color: white;
        transform: translateY(0);
        box-shadow: 2px 4px 10px rgba(215, 74, 9, 0.4);
        transition: all 0.1s ease-out;
    }

    @media screen and (max-width: 768px) {
        button {
            padding: 0 24px;
            font-size: 16px;
        }
    }
</style>

<button {disabled} use:textFloaty={floatText} bind:this={button} on:click={click}>
    <slot/>
</button>